import axios from "axios";
// import bus from "@/EventBus";

export default {
  namespaced: true,
  state: {
    cliente: {},
    clientes: []
  },
  mutations: {
    llenarCliente(state, clienteAccion) {
      state.cliente = clienteAccion;
    },
    llenarClientes(state, data) {
      state.clientes = data;
      // bus.$emit('cargarDeudas');
    },
  },
  actions: {
    getCliente: async function({ commit }, data_persona) {
      let persona = data_persona.persona
      let token = data_persona.token
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;
      
      await axios
        .get(`persona/query?_id=${persona._id}`,configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarCliente", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getClientes: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;
      
      await axios
        .get('persona/listClientes',configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarClientes", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateCliente: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      await axios
        .put('persona/update',{
          _id: data.obj._id,
          tipo_persona: data.obj.tipo_persona,
          tipo_cliente: data.obj.tipo_cliente,
          nombre: data.obj.nombre,
          tipo_documento: data.obj.tipo_documento,
          num_documento: data.obj.num_documento,
          direccion: data.obj.direccion,
          telefono: data.obj.telefono,
          email: data.obj.email,
          zona: data.obj.zona
        },configuracion)
        .then(function(res) {
          debugger
          dispatch('getClientes', data.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} fue actualizado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveCliente: async function({dispatch}, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      await axios
        .post('persona/add',{
          tipo_persona: data.obj.tipo_persona,
          tipo_cliente: data.obj.tipo_cliente,
          nombre: data.obj.nombre,
          tipo_documento: data.obj.tipo_documento,
          num_documento: data.obj.num_documento,
          direccion: data.obj.direccion,
          telefono: data.obj.telefono,
          email: data.obj.email,
          zona: data.obj.zona
        },configuracion)
        .then(function(res) {
          dispatch('getClientes', data.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} fue agregado exitosamente`,
            icon: "success",
          }); 
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateDeuda: async function({ dispatch }, data_persona) {
      let header = { Token: data_persona.token };
      let configuracion = { headers: header };
      debugger
      await axios
        .put('persona/updateDeuda',{
          _id: data_persona.id,
          pagado: data_persona.pagado,
          deuda: data_persona.deuda,
          descripcion: data_persona.descripcion
        },configuracion)
        .then(function(res) {
          dispatch('getClientes', data_persona.token)
          swal({
            title: "Buen trabajo!",
            text: `La deuda de ${res.data.nombre} fue actualizada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    activateCliente: async function({ dispatch }, data_persona) {
      let header = { Token: data_persona.token };
      let configuracion = { headers: header };
      await axios
        .put('persona/activate',{_id: data_persona.id,},configuracion)
        .then(function(res) {
          dispatch('getClientes', data_persona.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} fue activado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deactivateCliente: async function({ dispatch }, data_persona) {
      let header = { Token: data_persona.token };
      let configuracion = { headers: header };
      await axios
        .put('persona/deactivate',{_id: data_persona.id,},configuracion)
        .then(function(res) {
          dispatch('getClientes', data_persona.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} fue desactivado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deleteCliente: async function({ dispatch }, data_persona) {
      let token = data_persona.token
      let header = { Token: token };
      let configuracion = { headers: header };
      
      await axios
        .delete(`persona/remove?_id=${data_persona.id}`,configuracion)
        .then(function(res) {
          dispatch('getClientes', data_persona.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} fue eliminado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  }
};
